// dependencies
import React from "react";

import AsyncSelectInput from "../../../../../components/Inputs/AsyncSelectInput";

import useQueryBuilderStore from "../store";

interface BaseProps {
	onChange: (value: any) => void;
	value: string[];
}

const PeoplePicker = (props: BaseProps) => {
	const valueLabelPeopleMaps = useQueryBuilderStore.getState().valueLabelMaps.people;
	const { onChange, value } = props;

	const [fetchEmployees] = useQueryBuilderStore((state) => [state.fetchEmployees]);

	// needed for SelectInput to access labels for chips
	const valuesAsValueLabelObjects = value.map((val) => ({
		value: val,
		label: valueLabelPeopleMaps[val],
	}));

	return (
		<AsyncSelectInput
			isMultiSelect
			fetchOptions={fetchEmployees}
			onChange={onChange}
			value={valuesAsValueLabelObjects}
		/>
	);
};

export default PeoplePicker;
